import { create } from 'zustand';
import type { ReportTab } from '@/features/Strategies/features/Report/types';

/**
 * The report tab the advisor is currently viewing.
 *
 * The backtest report keeps its active tab in LOCAL component state, not the
 * URL (clicking a tab doesn't change `?tab=`), so the Soteria chat — which lives
 * in a separate panel/route — has no other way to know which charts are on
 * screen. The report publishes its active tab here; `useSoteriaChat` reads it
 * into the page context so "explain the plots" resolves to the right section.
 *
 * `null` whenever no report is mounted, so the chat only uses it on a report.
 */
interface ActiveReportTabState {
  tab: ReportTab | null;
  setTab: (tab: ReportTab | null) => void;
}

export const useActiveReportTab = create<ActiveReportTabState>((set) => ({
  tab: null,
  setTab: (tab) => set({ tab }),
}));
